/* ============================================================
   INDIGREY REDESIGN — PDP runtime
   Variant select, size tiles (letter + numeric, Option C), size guide,
   gallery swipe, accordions, promo copy, delivery bike animation.
   ============================================================ */
(function () {
  var pdp = document.querySelector('[data-ig-pdp]');
  if (!pdp) return;

  var form = document.getElementById('ig-rd-form');
  var idInput = pdp.querySelector('[data-ig-variant-id]');
  var variants = [];
  try { variants = JSON.parse(pdp.querySelector('[data-ig-variants]').textContent || '[]'); } catch (e) {}
  var colorPos = parseInt(pdp.getAttribute('data-color-pos') || '0', 10);
  var sizePos = parseInt(pdp.getAttribute('data-size-pos') || '0', 10);

  function money(cents) {
    // rupee formatting to match store (₹1,349)
    var n = (cents / 100);
    return '₹' + n.toLocaleString('en-IN', { maximumFractionDigits: (n % 1 ? 2 : 0) });
  }

  // current selection = options of the first available/selected variant
  var current = variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || variants[0] || null;
  var sel = current ? current.options.slice() : [];

  function findVariant() {
    return variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    })[0] || null;
  }

  function updateUI() {
    var v = findVariant();
    var addBtns = pdp.querySelectorAll('[data-ig-addtobag]');
    var buyBtn = pdp.querySelector('[data-ig-buynow]');
    if (v) {
      if (idInput) idInput.value = v.id;
      var priceEls = pdp.querySelectorAll('[data-ig-price], [data-ig-price-mirror]');
      priceEls.forEach(function (el) { el.textContent = money(v.price); });
      var wasEls = pdp.querySelectorAll('[data-ig-was], [data-ig-was-mirror]');
      wasEls.forEach(function (el) {
        if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = money(v.compare_at_price); el.hidden = false; }
        else { el.hidden = true; }
      });
      var unavailable = !v.available;
      addBtns.forEach(function (b) { b.disabled = unavailable; b.textContent = unavailable ? 'Sold out' : 'Add to bag'; });
      if (buyBtn) buyBtn.style.display = unavailable ? 'none' : '';
    } else {
      addBtns.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; });
      if (buyBtn) buyBtn.style.display = 'none';
    }
  }

  /* ---------- colour swatches ----------
     Colourways are separate linked products on this store, so the swatches are
     plain links that navigate — no variant switching needed here. */

  /* ---------- size selector (Option C tiles) ----------
     Every tile permanently shows BOTH labels — letter primary, numeric small
     beneath (spans rendered by Liquid). Selection only toggles the class; the
     old behaviour of swapping the selected tile's text to the bare number
     confused shoppers ("36" next to S/M/L read as a different scheme). */
  var sgLink = pdp.querySelector('[data-ig-sizeguide-open]');
  pdp.querySelectorAll('.ig-rd-pdp__size').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-disabled') || btn.disabled) return;
      var val = btn.getAttribute('data-size');
      if (sizePos > 0) sel[sizePos - 1] = val;
      pdp.querySelectorAll('.ig-rd-pdp__size').forEach(function (b) {
        b.classList.toggle('is-selected', b === btn);
      });
      // wiggle the "Size guide" link on select (prototype micro-interaction)
      if (sgLink) { sgLink.classList.remove('is-wiggle'); void sgLink.offsetWidth; sgLink.classList.add('is-wiggle'); }
      syncSizeGuideRow();
      syncStickySize();
      updateUI();
    });
  });

  /* mirror the chosen size into the sticky purchase bar — letter AND numeric,
     so "Size XL (44)" answers the letters-vs-numbers doubt right in the bar */
  function syncStickySize() {
    var el = pdp.querySelector('[data-ig-sticky-size]');
    if (!el) return;
    var b = pdp.querySelector('.ig-rd-pdp__size.is-selected');
    var letter = b ? b.getAttribute('data-letter') : null;
    var num = b ? b.getAttribute('data-numeric') : null;
    if (letter) {
      el.textContent = 'Size ' + letter + (num && num !== letter ? ' (' + num + ')' : '');
    } else {
      el.textContent = 'Select size';
    }
    el.classList.toggle('is-set', !!letter);
  }

  /* ---------- size guide ----------
     Opened exactly the way the live theme opens it: the hidden
     .product-size-guide-popup-source is cloned into an EasyDialogBox with the
     same classes, the same 300ms show, and the same post-open corrections
     (clearing the drag-positioning inline styles and re-anchoring the close
     button). Copied from main-product.js so the animation and chrome match
     rather than being approximated. Tabs, unit toggle and table rendering are
     handled by product-size-guide-v2.js's own delegated listener, which works
     on the cloned node. */
  function syncSizeGuideRow() { /* v2 popup has no per-size row highlight */ }
  function openSG() {
    var id = pdp.getAttribute('data-ig-sg-id');
    if (!id || typeof EasyDialogBox === 'undefined') return;
    var content = document.getElementById(id);
    if (!content) return;
    var dlg = EasyDialogBox.create(
      id,
      'dlg dlg-disable-heading dlg-disable-footer dlg-disable-drag',
      'Size guide',
      content.innerHTML
    );
    dlg.onClose = dlg.destroy;
    dlg.show(300);
    setTimeout(function () {
      document.querySelectorAll('.dlg[id^="popup-size-guide"].dialog-open').forEach(function (d) {
        var box = d.querySelector('.dlg-box');
        if (box) { box.style.left = ''; box.style.top = ''; box.style.right = ''; box.style.bottom = ''; box.style.margin = ''; }
      });
      document.querySelectorAll('.dlg[id^="popup-size-guide"] .dlg-close-x, .dlg-box[id^="popup-size-guide"] > .dlg-close-x').forEach(function (b) {
        b.style.left = 'auto'; b.style.right = '1.25rem'; b.style.top = '1.25rem';
        b.style.transform = 'none'; b.style.margin = '0';
      });
    }, 50);
  }
  if (sgLink) sgLink.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openSG(); });

  /* ---------- wishlist micro-confirmation ----------
     The old text banner ("Saved to wishlist") read as a system message. It is
     replaced by a drawn tick that fades over the heart for ~1s on save only —
     satisfying without demanding attention. Removal needs no badge: the heart
     easing back to an outline IS the confirmation. State for assistive tech
     still travels through the button's aria-pressed / aria-label, set in
     paintHeart(), so dropping the visible text costs nothing there.
     Driven off the event's own `saved` flag — never a DOM re-read. */
  var wishCheckT = 0;
  pdp.addEventListener('ig:wish', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.ig-rd-pdp__wish') : null;
    if (!btn) return;
    var saved = e.detail && e.detail.saved;
    btn.classList.remove('is-just-saved');
    if (saved) {
      /* reflow so the animation restarts even on a rapid re-save */
      void btn.offsetWidth;
      btn.classList.add('is-just-saved');
      clearTimeout(wishCheckT);
      wishCheckT = setTimeout(function () { btn.classList.remove('is-just-saved'); }, 1050);
    }
  });

  /* ---------- add to bag / buy now ---------- */
  function currentSizeLabel() {
    var b = pdp.querySelector('.ig-rd-pdp__size.is-selected');
    return b ? b.getAttribute('data-letter') : null;
  }
  pdp.querySelectorAll('[data-ig-addtobag]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var v = findVariant(); if (!v) return;
      if (window.IG) window.IG.addToCart(v.id, 1, currentSizeLabel());
    });
  });
  var buy = pdp.querySelector('[data-ig-buynow]');
  if (buy) buy.addEventListener('click', function () {
    var v = findVariant(); if (!v || !window.IG) return;
    // Add to the bag, then fire the NATIVE Shopify checkout submit (a
    // name="checkout" POST to /cart) — the exact control Razorpay Magic
    // Checkout intercepts, identical to the bag's Checkout button. A direct
    // window.location = '/checkout' bypassed Razorpay and dropped the shopper
    // onto Shopify's own checkout. If Razorpay ever isn't present the submit
    // simply proceeds to checkout, so there is no worse-than-before path.
    window.IG.addToCart(v.id, 1, currentSizeLabel()).then(function () {
      var f = document.createElement('form');
      f.action = '/cart'; f.method = 'post'; f.style.display = 'none';
      var b = document.createElement('button'); b.type = 'submit'; b.name = 'checkout';
      f.appendChild(b); document.body.appendChild(f);
      b.click();   // real click on a name="checkout" submit → Razorpay's handler fires
    }).catch(function () {});
  });

  /* ---------- copy promo ---------- */
  pdp.querySelectorAll('[data-ig-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var code = b.getAttribute('data-ig-copy');
      if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {});
      if (window.IG) window.IG.toast('Code copied');
    });
  });

  /* ---------- product-info accordion (Overview / Specifications / Materials /
     Wash care / Delivery / Returns) — each section toggles independently ---------- */
  pdp.querySelectorAll('[data-ig-acc-head]').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.closest('[data-ig-acc-item]');
      if (!item) return;
      var open = item.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- BACK ----------
     The href is a real collection link so it works with no JS and for a
     shopper who landed here cold. When there IS same-origin history, going
     back is the truer action — it returns them to their scroll position in the
     grid rather than reloading the collection at the top. */
  (function () {
    var back = pdp.querySelector('[data-ig-back]');
    if (!back) return;
    back.addEventListener('click', function (e) {
      var ref = document.referrer;
      var sameOrigin = ref && ref.indexOf(window.location.origin) === 0;
      if (history.length > 1 && sameOrigin) { e.preventDefault(); history.back(); }
    });
  })();

  /* ---------- MOBILE GALLERY — finger-tracking carousel ----------
     One transform-driven track holds every frame, so a drag moves the whole
     strip and the neighbouring image is already painted: the next photograph
     is revealed progressively rather than swapped in at the end. An incomplete
     swipe eases back to rest; a completed one carries its own momentum. */
  var hero = pdp.querySelector('[data-ig-hero]');
  var track = pdp.querySelector('[data-ig-track]');
  if (hero && track && track.children.length) {
    var slides = track.children;
    var count = slides.length;
    var dots = pdp.querySelectorAll('[data-ig-dots] .ig-rd-pdp__dot');
    var thumbs = pdp.querySelectorAll('[data-ig-thumbs] .ig-rd-pdp__thumb');
    var rail = pdp.querySelector('[data-ig-thumbs]');
    var EASE = 'transform .46s cubic-bezier(.22,1,.36,1)';
    var SNAP = 'transform .34s cubic-bezier(.33,1,.68,1)';
    var gIdx = 0, gW = 0;
    var down = false, sX = 0, sY = 0, dX = 0, axis = null, lastX = 0, lastT = 0, vel = 0;

    function measureGallery() { gW = hero.getBoundingClientRect().width || hero.offsetWidth || 0; }
    function setX(px, ease) {
      track.style.transition = ease || 'none';
      track.style.transform = 'translate3d(' + px + 'px,0,0)';
    }
    // Keep the active thumbnail visible by moving the RAIL's own scrollLeft —
    // never scrollIntoView(), which would drag the page with it. Only moves
    // when the thumb is actually outside the rail, and only by the shortfall,
    // so a selection never yanks the strip. The margin clears the selected
    // thumb's extra width so its lifted edge is never half-cut.
    var RAIL_PAD = 22;
    function revealThumb(t) {
      if (!rail || !t) return;
      var r = rail.getBoundingClientRect(), b = t.getBoundingClientRect();
      var delta = 0;
      if (b.left < r.left + RAIL_PAD) delta = (b.left - r.left) - RAIL_PAD;
      else if (b.right > r.right - RAIL_PAD) delta = (b.right - r.right) + RAIL_PAD;
      if (!delta) return;
      var to = rail.scrollLeft + delta;
      if (REDUCED_MOTION || !rail.scrollTo) { rail.scrollLeft = to; return; }
      rail.scrollTo({ left: to, behavior: 'smooth' });
      // Smooth scrolling is animation-driven: if the animation is dropped or
      // pre-empted (backgrounded tab, snap interference), land the rail anyway
      // rather than leaving the selected thumbnail off-screen.
      clearTimeout(revealThumb._t);
      revealThumb._t = setTimeout(function () {
        if (Math.abs(rail.scrollLeft - to) > 2) rail.scrollLeft = to;
      }, 460);
    }
    // Ensure the frames either side of the current one are decoded BEFORE they
    // can be dragged into view — a lazy neighbour would otherwise slide in
    // blank, which is exactly the flash this gallery is meant to avoid.
    function primeNeighbours(i) {
      [i - 1, i, i + 1].forEach(function (k) {
        if (k < 0 || k >= count) return;
        var im = slides[k].querySelector('img');
        if (im && im.loading === 'lazy') im.loading = 'eager';
      });
    }
    function paintGallery() {
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', i === gIdx);
      for (var j = 0; j < thumbs.length; j++) thumbs[j].classList.toggle('is-on', j === gIdx);
      revealThumb(thumbs[gIdx]);
      primeNeighbours(gIdx);
    }
    function goTo(i, ease) {
      gIdx = Math.max(0, Math.min(count - 1, i));
      if (!gW) measureGallery();
      setX(-gIdx * gW, ease === undefined ? EASE : ease);
      paintGallery();
    }

    measureGallery();
    setX(0, 'none');
    window.addEventListener('resize', function () {
      var prev = gW; measureGallery();
      if (gW !== prev) setX(-gIdx * gW, 'none');
    });

    if (count > 1) {
      hero.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (zoom.busy()) { down = false; return; }   // pinching or zoomed-in: zoom owns the gesture
        measureGallery();
        down = true; axis = null; dX = 0;
        sX = lastX = e.clientX; sY = e.clientY;
        lastT = e.timeStamp; vel = 0;
        track.style.transition = 'none';
      });

      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        if (zoom.busy()) { down = false; setX(-gIdx * gW, SNAP); return; }
        var x = e.clientX, y = e.clientY;
        if (axis === null) {
          var ax = Math.abs(x - sX), ay = Math.abs(y - sY);
          if (ax < 5 && ay < 5) return;
          axis = ax > ay ? 'x' : 'y';
          // vertical intent: hand the gesture back to the page immediately
          if (axis === 'y') { down = false; setX(-gIdx * gW, SNAP); return; }
        }
        dX = x - sX;
        // resistance at the ends — the strip pulls but does not run free
        if ((gIdx === 0 && dX > 0) || (gIdx === count - 1 && dX < 0)) dX *= 0.32;
        var dt = e.timeStamp - lastT;
        if (dt > 0) vel = (x - lastX) / dt;          // px per ms
        lastX = x; lastT = e.timeStamp;
        setX(-gIdx * gW + dX, 'none');
      }, { passive: true });

      function release() {
        if (!down) return;
        down = false;
        if (axis !== 'x') { setX(-gIdx * gW, SNAP); return; }
        var far = Math.abs(dX) > gW * 0.2;           // travelled far enough
        var fast = Math.abs(vel) > 0.36;             // or flicked
        var dir = dX < 0 ? 1 : -1;
        if ((far || fast) && gIdx + dir >= 0 && gIdx + dir < count) goTo(gIdx + dir, EASE);
        else setX(-gIdx * gW, SNAP);                 // incomplete → ease home
        dX = 0; axis = null;
      }
      window.addEventListener('pointerup', release);
      window.addEventListener('pointercancel', function () {
        if (!down) return;
        down = false; axis = null; dX = 0;
        setX(-gIdx * gW, SNAP);
      });
    }

    /* ---------- ZOOM — pinch and double-tap ----------
       A close look at the stitching, not a lightbox. The photograph scales up
       to MAX about the point the shopper indicated and then returns, so the
       gallery is never left in a state they have to undo.

         • pinch  — follows both fingers live, capped at MAX, springs back to
                    1x the moment the fingers lift.
         • double-tap — eases to MAX centred on the tap and holds, so it can be
                    studied one-handed; a further tap (or double-tap) returns
                    it. While held, one finger pans within the frame.

       Only the current slide is transformed, so the track, the dots and the
       thumbnails are all untouched and the swipe resumes exactly as before. */
    var zoom = (function () {
      var MAX = 1.6, SPRING = 'transform .34s cubic-bezier(.22,1,.36,1)';
      var pts = {}, n = 0;                 // live pointers on the hero
      var scale = 1, tx = 0, ty = 0;
      var pinching = false, held = false;  // held = parked at MAX after a double-tap
      var d0 = 1, s0 = 1, mid0 = null, base = { tx: 0, ty: 0 };
      var panning = false, panX = 0, panY = 0, panMoved = 0;
      var lastTap = 0, lastTapX = 0, lastTapY = 0, heldAt = 0;
      var savedTouch = '';

      function img() { return slides[gIdx] && slides[gIdx].querySelector('img'); }
      function apply(el, ease) {
        if (!el) return;
        el.style.transition = ease || 'none';
        el.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + scale + ')';
      }
      // never let the frame show empty ground: pan is bounded by the overhang
      function clamp() {
        var r = hero.getBoundingClientRect();
        var mx = Math.max(0, (r.width * scale - r.width) / 2);
        var my = Math.max(0, (r.height * scale - r.height) / 2);
        tx = Math.max(-mx, Math.min(mx, tx));
        ty = Math.max(-my, Math.min(my, ty));
      }
      // translation that keeps the point (px,py), measured from the frame's
      // centre, sitting still while the image scales around that centre
      function anchorTo(px, py, s) { return { tx: -px * (s - 1), ty: -py * (s - 1) }; }
      function centreOffset(cx, cy) {
        var r = hero.getBoundingClientRect();
        return { x: cx - (r.left + r.width / 2), y: cy - (r.top + r.height / 2) };
      }
      function lockTouch(on) {
        if (on) { if (hero.style.touchAction !== 'none') savedTouch = hero.style.touchAction; hero.style.touchAction = 'none'; }
        else { hero.style.touchAction = savedTouch || ''; }
      }
      // While the fingers are down the photograph is allowed to escape the
      // frame and float above the page, the way it does in Instagram. This is
      // transient only — the parked double-tap zoom stays clipped, because a
      // persistent overspill would just read as a layout fault.
      var overlayT = null;
      function overlay(on) {
        if (overlayT) { clearTimeout(overlayT); overlayT = null; }
        var sl = slides[gIdx];
        if (on) {
          hero.style.overflow = 'visible'; hero.style.zIndex = '40';
          if (sl) sl.style.zIndex = '2';
        } else {
          // wait for the spring home, or the image would snap back into the
          // clip while it is still travelling
          overlayT = setTimeout(function () {
            hero.style.overflow = ''; hero.style.zIndex = '';
            for (var i = 0; i < slides.length; i++) slides[i].style.zIndex = '';
            overlayT = null;
          }, 380);
        }
      }
      function reset(ease) {
        var el = img();
        scale = 1; tx = 0; ty = 0;
        apply(el, (ease === false || REDUCED_MOTION) ? 'none' : SPRING);
        held = false; pinching = false; panning = false;
        lockTouch(false); overlay(false);
        hero.classList.remove('is-zoomed');
      }

      /* touch-action is evaluated when a gesture BEGINS, so flipping it on the
         second pointerdown is already too late — the page has committed to
         scrolling and the pinch fights it. These native touch handlers cancel
         the in-flight scroll as soon as a second finger appears, which is what
         makes the zoom feel like it owns the gesture. */
      hero.addEventListener('touchstart', function (e) {
        if (e.touches.length >= 2) lockTouch(true);
      }, { passive: true });
      hero.addEventListener('touchmove', function (e) {
        if ((e.touches.length >= 2 || pinching || held) && e.cancelable) e.preventDefault();
      }, { passive: false });
      // Safety net: never leave the page unable to scroll. If every finger has
      // lifted and nothing is zoomed, hand scrolling back even if the matching
      // pointer events never arrived.
      function touchesDone(e) {
        if (e.touches.length === 0 && !pinching && !held && scale === 1) lockTouch(false);
      }
      hero.addEventListener('touchend', touchesDone, { passive: true });
      hero.addEventListener('touchcancel', touchesDone, { passive: true });

      hero.addEventListener('pointerdown', function (e) {
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        n = Object.keys(pts).length;
        if (n === 2) {
          var k = Object.keys(pts), a = pts[k[0]], b = pts[k[1]];
          d0 = Math.hypot(a.x - b.x, a.y - b.y) || 1;
          s0 = scale;
          base = { tx: tx, ty: ty };
          mid0 = centreOffset((a.x + b.x) / 2, (a.y + b.y) / 2);
          pinching = true; held = false;
          lockTouch(true); overlay(true);
          hero.classList.add('is-zoomed');
        } else if (n === 1 && held) {
          panning = true; panX = e.clientX; panY = e.clientY; panMoved = 0;
        }
      });

      window.addEventListener('pointermove', function (e) {
        if (!pts[e.pointerId]) return;
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        if (pinching && Object.keys(pts).length >= 2) {
          var k = Object.keys(pts), a = pts[k[0]], b = pts[k[1]];
          var d = Math.hypot(a.x - b.x, a.y - b.y) || 1;
          scale = Math.max(1, Math.min(MAX, s0 * (d / d0)));
          // the image tracks the fingers as they move, not just as they spread
          var mid = centreOffset((a.x + b.x) / 2, (a.y + b.y) / 2);
          var t = anchorTo(mid0.x, mid0.y, scale);
          tx = base.tx + t.tx + (mid.x - mid0.x);
          ty = base.ty + t.ty + (mid.y - mid0.y);
          apply(img(), 'none');            // no clamp mid-pinch — it springs home anyway
        } else if (panning && held) {
          panMoved += Math.abs(e.clientX - panX) + Math.abs(e.clientY - panY);
          tx += e.clientX - panX; ty += e.clientY - panY;
          panX = e.clientX; panY = e.clientY;
          clamp();
          apply(img(), 'none');
        }
      }, { passive: true });

      function lift(e) {
        if (!pts[e.pointerId]) return;
        delete pts[e.pointerId];
        n = Object.keys(pts).length;
        if (pinching && n < 2) { pinching = false; reset(); return; }  // fingers lifted → spring home
        if (panning && n === 0) panning = false;
      }
      window.addEventListener('pointerup', lift);
      window.addEventListener('pointercancel', function (e) {
        if (!pts[e.pointerId]) return;
        delete pts[e.pointerId];
        n = Object.keys(pts).length;
        if (pinching && n < 2) { pinching = false; reset(); }
      });

      // double-tap: two quick taps in the same spot, and not the tail of a swipe
      hero.addEventListener('pointerup', function (e) {
        if (pinching) return;
        var now = Date.now();
        var quick = now - lastTap < 320;
        var near = Math.abs(e.clientX - lastTapX) < 34 && Math.abs(e.clientY - lastTapY) < 34;
        lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY;
        // Parked at MAX: any TAP returns the photograph. Checked here rather
        // than relying on the synthesised click, and gated on movement so that
        // lifting after a pan does not dismiss the zoom the shopper is using.
        if (held) { if (panMoved < 10) { reset(); lastTap = 0; } return; }
        if (!quick || !near) return;
        lastTap = 0;                              // a third tap starts a new pair
        if (scale > 1) { reset(); return; }
        var o = centreOffset(e.clientX, e.clientY);
        scale = MAX;
        var t = anchorTo(o.x, o.y, scale);
        tx = t.tx; ty = t.ty; clamp();
        apply(img(), REDUCED_MOTION ? 'none' : SPRING);
        held = true; heldAt = now; panMoved = 0; lockTouch(true);
        hero.classList.add('is-zoomed');
      });

      return {
        busy: function () { return pinching || held || scale > 1; },
        clear: function () { if (scale > 1 || held) reset(false); }
      };
    })();

    for (var t = 0; t < thumbs.length; t++) {
      (function (btn) {
        btn.addEventListener('click', function () { goTo(parseInt(btn.getAttribute('data-idx'), 10), EASE); });
      })(thumbs[t]);
    }
    paintGallery();
    // changing frame must never leave the previous one zoomed
    var _goTo = goTo;
    goTo = function (i, ease) { zoom.clear(); _goTo(i, ease); };
  }

  /* Coalesce scroll work to one measurement per frame — but never latch. If a
     requested frame never arrives (throttled or backgrounded renderer), the
     next scroll runs the check synchronously instead of going permanently
     deaf. Shared by the delayed header and the sticky purchase bar. */
  function frameThrottle(fn) {
    var rafId = 0, reqAt = 0;
    return function () {
      var now = Date.now();
      if (rafId) {
        if (now - reqAt < 300) return;
        cancelAnimationFrame(rafId); rafId = 0; fn();
        return;
      }
      reqAt = now;
      rafId = requestAnimationFrame(function () { rafId = 0; fn(); });
    };
  }

  /* ---------- DELAYED STICKY HEADER (mobile) ----------
     The photography leads. The header stays in normal flow and scrolls away
     with the page; only once the shopper is ~45% through the hero gallery does
     a compact header slide down over the content. The theme's own .headerSpace
     spacer is revealed at the SAME moment the header leaves flow, and at
     exactly its natural height, so the document never reflows — the transition
     is purely the header sliding in. */
  (function () {
    /* DELAYED STICKY HEADER — header scrolls away with the product photo, then the
       FULL header (not compact — see the CSS) slides back in and sticks once the
       hero photo has passed. The old compact/overflow:hidden version clipped the
       search drawer; the CSS now keeps it full and un-clipped. */
    var hdr = document.getElementById('sticky-header');
    var galM = pdp.querySelector('[data-ig-gal-m]');
    var heroEl = pdp.querySelector('[data-ig-hero]');
    if (!hdr || !galM || !heroEl) return;
    var root = document.documentElement, body = document.body;
    var natural = 0, threshold = 0, isFixed = false, unfixTimer = null;

    function spacer() { return document.querySelector('.headerSpace'); }

    function measureHeader() {
      if (window.innerWidth > 989) return;
      if (!isFixed) {
        var h = Math.round(hdr.getBoundingClientRect().height);
        if (h > 10) natural = h;
      }
      if (natural) {
        root.style.setProperty('--ig-hdr-compact', Math.round(natural * 0.83) + 'px');
        var sp = spacer();
        if (sp) sp.style.height = natural + 'px';   // exact — no jump on swap
      }
      var r = heroEl.getBoundingClientRect();
      var docTop = r.top + (window.pageYOffset || root.scrollTop);
      /* trigger once the product photo has fully passed (~one screen), not partway
         through it — so the header re-sticks after the hero, per the design. */
      threshold = Math.round(docTop + Math.max(r.height, window.innerHeight) * 0.92);
    }

    function fix() {
      if (isFixed) return;
      isFixed = true;
      if (unfixTimer) { clearTimeout(unfixTimer); unfixTimer = null; }
      // Snap to the hidden (translateY(-100%)) frame INSTANTLY — transition off —
      // otherwise the 1s transition animates 0 -> -100% and fights the reveal, so
      // the header barely moves and looks instant. Then restore the CSS transition
      // so the reveal (-100% -> 0) actually slides over its full duration.
      hdr.style.transition = 'none';
      body.classList.add('ig-hdr-fixed');
      void hdr.offsetHeight;                        // commit the hidden frame
      hdr.style.transition = '';                    // restore the CSS 1s slide
      // Reveal on the next frame so the slide animates from -100% -> 0. A timeout
      // backstop guarantees the header is never left fixed-but-invisible if the
      // frame is dropped (backgrounded tab, throttled renderer).
      var reveal = function () { if (isFixed) body.classList.add('ig-hdr-in'); };
      requestAnimationFrame(reveal);
      setTimeout(reveal, 80);
    }
    function unfix() {
      if (!isFixed) return;
      isFixed = false;
      body.classList.remove('ig-hdr-in');
      unfixTimer = setTimeout(function () {
        if (!isFixed) body.classList.remove('ig-hdr-fixed');
        unfixTimer = null;
      }, 1050);   /* match the 1s slide so the header isn't cut off mid-animation */
    }

    function tick() {
      if (window.innerWidth > 989) { unfix(); return; }
      if (!threshold) measureHeader();
      var y = window.pageYOffset || root.scrollTop || 0;
      if (!isFixed && y > threshold) fix();
      else if (isFixed && y < threshold - 48) unfix();   // hysteresis, no flicker
    }
    var onScroll = frameThrottle(tick);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measureHeader(); onScroll(); });
    window.addEventListener('load', function () { measureHeader(); onScroll(); });
    measureHeader(); onScroll();
  })();

  /* ---------- STICKY PURCHASE BAR ----------
     Revealed only once the size selector has scrolled ABOVE the viewport. */
  (function () {
    var bar = pdp.querySelector('[data-ig-stickybar]');
    var watch = pdp.querySelector('[data-ig-sizes]') || pdp.querySelector('.ig-rd-pdp__actions');
    if (!bar || !watch) return;
    function check() {
      // in only once the size selector has passed ABOVE the viewport
      bar.classList.toggle('is-in', watch.getBoundingClientRect().bottom < 0);
    }
    var onScroll = frameThrottle(check);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  })();

  /* ---------- check-delivery + simple truck animation ---------- */
  var del = pdp.querySelector('[data-ig-delivery]');
  if (del) {
    var body = del.querySelector('[data-ig-delivery-body]');
    /* Check delivery is always open now — no collapse toggle. The optional
       toggle wiring is kept for backward-compatibility if the header ever exists. */
    var delToggle = del.querySelector('[data-ig-delivery-toggle]');
    if (delToggle) delToggle.addEventListener('click', function () {
      var open = del.classList.toggle('is-open');
      body.hidden = !open;
      delToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var pin = del.querySelector('[data-ig-pincode]');
    var checkBtn = del.querySelector('[data-ig-delivery-check]');
    var resultEl = del.querySelector('[data-ig-delivery-result]');
    var scene = del.querySelector('[data-ig-delivery-scene]');
    var truck = del.querySelector('[data-ig-truck]');
    var benefits = del.querySelector('[data-ig-benefits]');
    var bShip = del.querySelector('[data-ig-ship]'), bExch = del.querySelector('[data-ig-exchange]'), bDel = del.querySelector('[data-ig-delivered]');
    var dateEl = del.querySelector('[data-ig-delivered-date]');
    var timers = [];

    function at(ms, fn) { timers.push(setTimeout(fn, ms)); }
    function clearAll() { timers.forEach(clearTimeout); timers = []; }
    function resetNotes() { [bShip, bExch, bDel].forEach(function (b) { b.classList.remove('is-on'); }); }
    function resetBtn() { checkBtn.textContent = 'Check'; checkBtn.disabled = false; }

    if (pin) pin.addEventListener('input', function () {
      clearAll(); resultEl.hidden = true; scene.hidden = true; resetBtn();
      if (truck) truck.classList.remove('is-driving');
    });

    checkBtn.addEventListener('click', function () {
      var p = (pin.value || '').trim();
      clearAll();
      if (!/^\d{6}$/.test(p)) { resultEl.textContent = 'Please enter a valid 6-digit pincode'; resultEl.hidden = false; return; }
      resultEl.hidden = true;
      checkBtn.textContent = 'Checking…'; checkBtn.disabled = true;

      /* every click replays: reset the notes, show the scene, then snap the truck
         back to the start (transition:none) and drive it out again from the left */
      resetNotes(); benefits.hidden = true;
      scene.hidden = false;
      truck.style.transition = 'none';
      truck.classList.remove('is-driving');
      void truck.offsetWidth;                 /* commit the snapped-back start */
      truck.style.transition = '';
      truck.classList.add('is-driving');      /* transition (left 2.4s) to the line end */

      var d = new Date(Date.now() + 8 * 86400000);
      dateEl.textContent = d.toLocaleDateString('en-IN', { day: 'numeric', month: 'long' });

      /* reveal the three notes as the truck travels; the last lands as it stops */
      benefits.hidden = false;
      at(500,  function () { bShip.classList.add('is-on'); });
      at(1100, function () { bExch.classList.add('is-on'); });
      at(2350, function () { bDel.classList.add('is-on'); resetBtn(); });
    });
  }

  /* ---------- craft profile: number formatting + scroll reveal ---------- */
  (function () {
    pdp.querySelectorAll('[data-ig-cp-num]').forEach(function (el) {
      var n = Number(el.getAttribute('data-ig-cp-num'));
      if (isFinite(n) && n) el.textContent = n.toLocaleString('en-US');
    });
    var band = pdp.querySelector('[data-ig-craftprofile]');
    if (band) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { threshold: .14 });
        io.observe(band);
      } else {
        band.classList.add('is-in');
      }
    }
  })();

  /* init */
  syncStickySize();
  updateUI();
})();
